import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

// Renders an otpauth:// URL as a scannable QR code entirely client-side —
// the secret never leaves the browser (no third-party QR image service).
export default function TOTPQRCode({ otpauthUrl }: { otpauthUrl: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    QRCode.toDataURL(otpauthUrl, { width: 200, margin: 1 })
      .then((url) => { if (!cancelled) setDataUrl(url) })
      .catch(() => { if (!cancelled) setDataUrl(null) })
    return () => { cancelled = true }
  }, [otpauthUrl])

  if (!dataUrl) return null
  return (
    <img
      src={dataUrl}
      alt="Scan with your authenticator app"
      width={200}
      height={200}
      style={{ display: 'block', marginBottom: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
    />
  )
}
